import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import TransactionApi from '../../api/TransactionApi';

const LineChart = () => {
  const getMonthName = (monthNumber) => {
    const months = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    return months[monthNumber];
  };

  const [monthlyProfits, setMonthlyProfits] = useState(Array(12).fill(0));
  const [categoryIncomes, setCategoryIncomes] = useState({});
  const [totalIncome, setTotalIncome] = useState(0);
  const [totalIncomes, setTotalIncomes] = useState(Array(12).fill(0));
  const [categoryExpenses, setCategoryExpenses] = useState({});
  const [totalExpense, setTotalExpense] = useState(0);
  const [totalExpenses, setTotalExpenses] = useState(Array(12).fill(0));

  const getTransactions = async () => {
    const res = await TransactionApi.index(); // Assuming this returns all transactions

    const categoryData = {};
    const incomeData = {};
    const expenseData = {};

    res.forEach((transaction) => {
      const { amount, paid_at, type, cat_name } = transaction;
      const parsedAmount = parseFloat(amount);
      const monthIndex = new Date(paid_at).getMonth();
      const categoryName = cat_name || 'Uncategorized';

      if (!categoryData[categoryName]) {
        categoryData[categoryName] = Array(12).fill(0).map(() => ({ income: 0, expense: 0 }));
      }

      if (type === 'income') {
        if (!incomeData[categoryName]) {
          incomeData[categoryName] = Array(12).fill(0);
        }
        categoryData[categoryName][monthIndex].income += parsedAmount;
        incomeData[categoryName][monthIndex] += parsedAmount;
      } else if (type === 'expense') {
        if (!expenseData[categoryName]) {
          expenseData[categoryName] = Array(12).fill(0);
        }
        categoryData[categoryName][monthIndex].expense += parsedAmount;
        expenseData[categoryName][monthIndex] += parsedAmount;
      }
    });

    const totalIncomes = Array(12).fill(0).map((_, monthIndex) => {
      return Object.values(incomeData).reduce(
        (sum, monthlyData) => sum + monthlyData[monthIndex],
        0
      ).toFixed(2); 
    });
    

    
    const totalExpenses = Array(12)
    .fill(0)
    .map((_, monthIndex) => {
      return Object.values(expenseData).reduce(
        (sum, monthlyData) => Math.round((sum + monthlyData[monthIndex]) * 100) / 100,
        0
      );
    });


    const monthlyProfits = totalIncomes.map((income, index) => income - totalExpenses[index]);

    setCategoryIncomes(incomeData);
    setTotalIncomes(totalIncomes);
    setTotalIncome(totalIncomes.reduce((sum, income) => sum + income, 0));

    setCategoryExpenses(expenseData);
    setTotalExpenses(totalExpenses);
    setTotalExpense(totalExpenses.reduce((sum, expense) => sum + expense, 0));

    setMonthlyProfits(monthlyProfits);
  };

  useEffect(() => {
    getTransactions();
  }, []);

  const options = {
    chart: {
      type: 'line'
    },
    stroke: {
      curve: 'smooth'
    },
    series: [
      {
        name: 'Income',
        data: totalIncomes
      },
      {
        name: 'Expense',
        data: totalExpenses
      },
      {
        name: 'Profit',
        data: monthlyProfits
      }
    ],
    xaxis: {
      categories: Array.from({ length: 12 }, (_, i) => getMonthName(i))
    }
  };

  return (
    <div id="chart">
      <div className='text-xl mb-2'>Income vs Expense</div>
      <Chart
        options={options}
        series={options.series}
        type="line"
        // height="100%"
      />
    </div>
  );
};

export default LineChart;
